import { Classification } from "@/src/models/constants/classifications";
import type { Section } from "@/src/models/section";

/**
 * Default shape for Section objects. Separate file to avoid circular dependencies.
 */
export const sectionShape: Section = {
  id: "",
  groupId: "",
  pathToFile: "",
  filename: "",
  contentType: "",
  checksum: "",
  status: "processed" as Section["status"],
  classification: Classification.IDENTIFICATION_CARD,
  fileSize: 0,
  processedContent: null,
  processedContentMetadata: null,
  enrichedContent: null,
  reviewedContent: null,
  classificationConfidence: null,
  splitDocumentConfidence: null,
  reviewedSplitDocumentConfidence: null,

  batchOperationName: null,
  batchExtractId: null,
  extractId: null,
  fileId: null,
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  vlmProcessedContent: null,
  geminiProcessedContent: null,
  pages: [1],
  ehrDocumentId: null,
  ehrDocumentType: null,
  metadata: null,
  intakeClassification: null,
  uploadClassification: null,
  intakePathToFile: null,
  uploadPathToFile: null,
  intakeSectionId: null,
  uploadSectionId: null,
  intakePages: null,
  uploadPages: null,
  isDuplicate: false,
  hasMultiplePatients: false,
  completedAt: null,
  extractionGroundTruth: null,
  source: "standard" as Section["source"],
};
